export const popularCountries = [
  {
    phoneCode: '+7',
    code: 'KZ',
    name: 'Казахстан',
    nameKK: 'Қазақстан',
    nameEN: 'Kazakhstan',
  },
  {
    phoneCode: '+7',
    code: 'RU',
    name: 'Россия',
    nameKK: 'Ресей',
    nameEN: 'Russia',
  },
  {
    phoneCode: '+998',
    code: 'UZ',
    name: 'Узбекистан',
    nameKK: 'Өзбекстан',
    nameEN: 'Uzbekistan',
  },
  {
    phoneCode: '+375',
    code: 'BY',
    name: 'Беларусь',
    nameKK: 'Беларусь',
    nameEN: 'Belarus',
  },
  {
    phoneCode: '+86',
    code: 'CN',
    name: 'Китай',
    nameKK: 'Қытай',
    nameEN: 'China',
  },
];

export const countryList = [
  ...popularCountries,
  {
    phoneCode: '+61',
    code: 'AU',
    name: 'Австралия',
    nameKK: 'Австралия',
    nameEN: 'Australia',
  },
  {
    phoneCode: '+43',
    code: 'AT',
    name: 'Австрия',
    nameKK: 'Австрия',
    nameEN: 'Austria',
  },
  {
    phoneCode: '+994',
    code: 'AZ',
    name: 'Азербайджан',
    nameKK: 'Әзірбайжан',
    nameEN: 'Azerbaijan',
  },
  {
    phoneCode: '+355',
    code: 'AL',
    name: 'Албания',
    nameKK: 'Албания',
    nameEN: 'Albania',
  },
  {
    phoneCode: '+213',
    code: 'DZ',
    name: 'Алжир',
    nameKK: 'Алжир',
    nameEN: 'Algeria',
  },
  {
    phoneCode: '+684',
    code: 'AS',
    name: 'Американское Самоа',
    nameKK: 'Американдық Самоа',
    nameEN: 'American Samoa',
  },
  {
    phoneCode: '+1264',
    code: 'AI',
    name: 'Ангилья',
    nameKK: 'Ангилья',
    nameEN: 'Anguilla',
  },
  {
    phoneCode: '+244',
    code: 'AO',
    name: 'Ангола',
    nameKK: 'Ангола',
    nameEN: 'Angola',
  },
  {
    phoneCode: '+376',
    code: 'AD',
    name: 'Андорра',
    nameKK: 'Андорра',
    nameEN: 'Andorra',
  },
  {
    phoneCode: '+1268',
    code: 'AG',
    name: 'Антигуа и Барбуда',
    nameKK: 'Антигуа және Барбуда',
    nameEN: 'Antigua and Barbuda',
  },
  {
    phoneCode: '+599',
    code: 'AN',
    name: 'Антильские острова',
    nameKK: 'Антиль аралдары',
    nameEN: 'Netherlands Antilles',
  },
  {
    phoneCode: '+54',
    code: 'AR',
    name: 'Аргентина',
    nameKK: 'Аргентина',
    nameEN: 'Argentina',
  },
  {
    phoneCode: '+374',
    code: 'AM',
    name: 'Армения',
    nameKK: 'Армения',
    nameEN: 'Armenia',
  },
  {
    phoneCode: '+297',
    code: 'AW',
    name: 'Аруба',
    nameKK: 'Аруба',
    nameEN: 'Aruba',
  },
  {
    phoneCode: '+93',
    code: 'AF',
    name: 'Афганистан',
    nameKK: 'Ауғанстан',
    nameEN: 'Afghanistan',
  },
  {
    phoneCode: '+1242',
    code: 'BS',
    name: 'Багамы',
    nameKK: 'Багам аралдары',
    nameEN: 'Bahamas',
  },
  {
    phoneCode: '+880',
    code: 'BD',
    name: 'Бангладеш',
    nameKK: 'Бангладеш',
    nameEN: 'Bangladesh',
  },
  {
    phoneCode: '+1246',
    code: 'BB',
    name: 'Барбадос',
    nameKK: 'Барбадос',
    nameEN: 'Barbados',
  },
  {
    phoneCode: '+973',
    code: 'BH',
    name: 'Бахрейн',
    nameKK: 'Бахрейн',
    nameEN: 'Bahrain',
  },
  {
    phoneCode: '+501',
    code: 'BZ',
    name: 'Белиз',
    nameKK: 'Белиз',
    nameEN: 'Belize',
  },
  {
    phoneCode: '+32',
    code: 'BE',
    name: 'Бельгия',
    nameKK: 'Бельгия',
    nameEN: 'Belgium',
  },
  {
    phoneCode: '+229',
    code: 'BJ',
    name: 'Бенин',
    nameKK: 'Бенин',
    nameEN: 'Benin',
  },
  {
    phoneCode: '+1441',
    code: 'BM',
    name: 'Бермуды',
    nameKK: 'Бермуд аралдары',
    nameEN: 'Bermuda',
  },
  {
    phoneCode: '+359',
    code: 'BG',
    name: 'Болгария',
    nameKK: 'Болгария',
    nameEN: 'Bulgaria',
  },
  {
    phoneCode: '+591',
    code: 'BO',
    name: 'Боливия',
    nameKK: 'Боливия',
    nameEN: 'Bolivia',
  },
  {
    phoneCode: '+387',
    code: 'BA',
    name: 'Босния и Герцеговина',
    nameKK: 'Босния және Герцеговина',
    nameEN: 'Bosnia and Herzegovina',
  },
  {
    phoneCode: '+267',
    code: 'BW',
    name: 'Ботсвана',
    nameKK: 'Ботсвана',
    nameEN: 'Botswana',
  },
  {
    phoneCode: '+55',
    code: 'BR',
    name: 'Бразилия',
    nameKK: 'Бразилия',
    nameEN: 'Brazil',
  },
  {
    phoneCode: '+0',
    code: 'IO',
    name: 'Британские Территории в Индийском Океане',
    nameKK: 'Үнді Мұхитындағы Британдық территориялар',
    nameEN: 'British Indian Ocean Territory',
  },
  {
    phoneCode: '+673',
    code: 'BN',
    name: 'Бруней',
    nameKK: 'Бруней',
    nameEN: 'Brunei',
  },
  {
    phoneCode: '+226',
    code: 'BF',
    name: 'Буркина-Фасо',
    nameKK: 'Буркина-Фасо',
    nameEN: 'Burkina Faso',
  },
  {
    phoneCode: '+257',
    code: 'BI',
    name: 'Бурунди',
    nameKK: 'Бурунди',
    nameEN: 'Burundi',
  },
  {
    phoneCode: '+975',
    code: 'BT',
    name: 'Бутан',
    nameKK: 'Бутан',
    nameEN: 'Bhutan',
  },
  {
    phoneCode: '+678',
    code: 'VU',
    name: 'Вануату',
    nameKK: 'Вануату',
    nameEN: 'Vanuatu',
  },
  {
    phoneCode: '+39',
    code: 'VA',
    name: 'Ватикан',
    nameKK: 'Ватикан',
    nameEN: 'Vatican',
  },
  {
    phoneCode: '+44',
    code: 'GB',
    name: 'Великобритания',
    nameKK: 'Ұлыбритания',
    nameEN: 'United Kingdom',
  },
  {
    phoneCode: '+36',
    code: 'HU',
    name: 'Венгрия',
    nameKK: 'Венгрия',
    nameEN: 'Hungary',
  },
  {
    phoneCode: '+58',
    code: 'VE',
    name: 'Венесуэла',
    nameKK: 'Венесуэла',
    nameEN: 'Venezuela',
  },
  {
    phoneCode: '+1284',
    code: 'VG',
    name: 'Виргинские острова',
    nameKK: 'Виргин аралдары',
    nameEN: 'Virgin Islands',
  },
  {
    phoneCode: '+670',
    code: 'TL',
    name: 'Восточный Тимор',
    nameKK: 'Шығыс Тимор',
    nameEN: 'East Timor',
  },
  {
    phoneCode: '+84',
    code: 'VN',
    name: 'Вьетнам',
    nameKK: 'Вьетнам',
    nameEN: 'Vietnam',
  },
  {
    phoneCode: '+241',
    code: 'GA',
    name: 'Габон',
    nameKK: 'Габон',
    nameEN: 'Gabon',
  },
  {
    phoneCode: '+509',
    code: 'HT',
    name: 'Гаити',
    nameKK: 'Гаити',
    nameEN: 'Haiti',
  },
  {
    phoneCode: '+592',
    code: 'GY',
    name: 'Гайана',
    nameKK: 'Гайана',
    nameEN: 'Guyana',
  },
  {
    phoneCode: '+220',
    code: 'GM',
    name: 'Гамбия',
    nameKK: 'Гамбия',
    nameEN: 'Gambia',
  },
  {
    phoneCode: '+233',
    code: 'GH',
    name: 'Гана',
    nameKK: 'Гана',
    nameEN: 'Ghana',
  },
  {
    phoneCode: '+502',
    code: 'GT',
    name: 'Гватемала',
    nameKK: 'Гватемала',
    nameEN: 'Guatemala',
  },
  {
    phoneCode: '+224',
    code: 'GN',
    name: 'Гвинея',
    nameKK: 'Гвинея',
    nameEN: 'Guinea',
  },
  {
    phoneCode: '+245',
    code: 'GW',
    name: 'Гвинея-Биссау',
    nameKK: 'Гвинея-Биссау',
    nameEN: 'Guinea-Bissau',
  },
  {
    phoneCode: '+49',
    code: 'DE',
    name: 'Германия',
    nameKK: 'Германия',
    nameEN: 'Germany',
  },
  {
    phoneCode: '+1481',
    code: 'GG',
    name: 'Гернси',
    nameKK: 'Гернси',
    nameEN: 'Guernsey',
  },
  {
    phoneCode: '+350',
    code: 'GI',
    name: 'Гибралтар',
    nameKK: 'Гибралтар',
    nameEN: 'Gibraltar',
  },
  {
    phoneCode: '+504',
    code: 'HN',
    name: 'Гондурас',
    nameKK: 'Гондурас',
    nameEN: 'Honduras',
  },
  {
    phoneCode: '+852',
    code: 'HK',
    name: 'Гонконг',
    nameKK: 'Гонконг',
    nameEN: 'Hong Kong',
  },
  {
    phoneCode: '+1473',
    code: 'GD',
    name: 'Гренада',
    nameKK: 'Гренада',
    nameEN: 'Grenada',
  },
  {
    phoneCode: '+299',
    code: 'GL',
    name: 'Гренландия',
    nameKK: 'Гренландия',
    nameEN: 'Greenland',
  },
  {
    phoneCode: '+30',
    code: 'GR',
    name: 'Греция',
    nameKK: 'Греция',
    nameEN: 'Greece',
  },
  {
    phoneCode: '+995',
    code: 'GE',
    name: 'Грузия',
    nameKK: 'Грузия',
    nameEN: 'Georgia',
  },
  {
    phoneCode: '+671',
    code: 'GU',
    name: 'Гуам',
    nameKK: 'Гуам',
    nameEN: 'Guam',
  },
  {
    phoneCode: '+45',
    code: 'DK',
    name: 'Дания',
    nameKK: 'Дания',
    nameEN: 'Denmark',
  },
  {
    phoneCode: '+253',
    code: 'DJ',
    name: 'Джибути',
    nameKK: 'Джибути',
    nameEN: 'Djibouti',
  },
  {
    phoneCode: '+1767',
    code: 'DM',
    name: 'Доминика',
    nameKK: 'Доминика',
    nameEN: 'Dominica',
  },
  {
    phoneCode: '+1809',
    code: 'DO',
    name: 'Доминиканская Республика',
    nameKK: 'Доминикан Республикасы',
    nameEN: 'Dominican Republic',
  },
  {
    phoneCode: '+20',
    code: 'EG',
    name: 'Египет',
    nameKK: 'Египет',
    nameEN: 'Egypt',
  },
  {
    phoneCode: '+260',
    code: 'ZM',
    name: 'Замбия',
    nameKK: 'Замбия',
    nameEN: 'Zambia',
  },
  {
    phoneCode: '+212',
    code: 'EH',
    name: 'Зап Сахара',
    nameKK: 'Зап Қант',
    nameEN: 'Western Sahara',
  },
  {
    phoneCode: '+263',
    code: 'ZW',
    name: 'Зимбабве',
    nameKK: 'Зимбабве',
    nameEN: 'Zimbabwe',
  },
  {
    phoneCode: '+972',
    code: 'IL',
    name: 'Израиль',
    nameKK: 'Израиль',
    nameEN: 'Israel',
  },
  {
    phoneCode: '+91',
    code: 'IN',
    name: 'Индия',
    nameKK: 'Үндістан',
    nameEN: 'India',
  },
  {
    phoneCode: '+62',
    code: 'ID',
    name: 'Индонезия',
    nameKK: 'Индонезия',
    nameEN: 'Indonesia',
  },
  {
    phoneCode: '+962',
    code: 'JO',
    name: 'Иордания',
    nameKK: 'Иордания',
    nameEN: 'Jordan',
  },
  {
    phoneCode: '+964',
    code: 'IQ',
    name: 'Ирак',
    nameKK: 'Ирак',
    nameEN: 'Iraq',
  },
  {
    phoneCode: '+98',
    code: 'IR',
    name: 'Иран',
    nameKK: 'Иран',
    nameEN: 'Iran',
  },
  {
    phoneCode: '+353',
    code: 'IE',
    name: 'Ирландия',
    nameKK: 'Ирландия',
    nameEN: 'Ireland',
  },
  {
    phoneCode: '+354',
    code: 'IS',
    name: 'Исландия',
    nameKK: 'Исландия',
    nameEN: 'Iceland',
  },
  {
    phoneCode: '+34',
    code: 'ES',
    name: 'Испания',
    nameKK: 'Испания',
    nameEN: 'Spain',
  },
  {
    phoneCode: '+39',
    code: 'IT',
    name: 'Италия',
    nameKK: 'Италия',
    nameEN: 'Italy',
  },
  {
    phoneCode: '+967',
    code: 'YE',
    name: 'Йемен',
    nameKK: 'Йемен',
    nameEN: 'Yemen',
  },
  {
    phoneCode: '+238',
    code: 'CV',
    name: 'Кабо-Верде',
    nameKK: 'Кабо-Верде',
    nameEN: 'Cape Verde',
  },
  {
    phoneCode: '+1345',
    code: 'KY',
    name: 'Каймановы острова',
    nameKK: 'Кайман аралдары',
    nameEN: 'Cayman Islands',
  },
  {
    phoneCode: '+855',
    code: 'KH',
    name: 'Камбоджа',
    nameKK: 'Камбоджа',
    nameEN: 'Cambodia',
  },
  {
    phoneCode: '+237',
    code: 'CM',
    name: 'Камерун',
    nameKK: 'Камерун',
    nameEN: 'Cameroon',
  },
  {
    phoneCode: '+1',
    code: 'CA',
    name: 'Канада',
    nameKK: 'Канада',
    nameEN: 'Canada',
  },
  {
    phoneCode: '+974',
    code: 'QA',
    name: 'Катар',
    nameKK: 'Катар',
    nameEN: 'Qatar',
  },
  {
    phoneCode: '+254',
    code: 'KE',
    name: 'Кения',
    nameKK: 'Кения',
    nameEN: 'Kenya',
  },
  {
    phoneCode: '+357',
    code: 'CY',
    name: 'Кипр',
    nameKK: 'Кипр',
    nameEN: 'Cyprus',
  },
  {
    phoneCode: '+996',
    code: 'KG',
    name: 'Киргизия',
    nameKK: 'Қырғызстан',
    nameEN: 'Kyrgyzstan',
  },
  {
    phoneCode: '+686',
    code: 'KI',
    name: 'Кирибати',
    nameKK: 'Кирибати',
    nameEN: 'Kiribati',
  },
  {
    phoneCode: '+6722',
    code: 'CC',
    name: 'Кокосовые острова',
    nameKK: 'Кокос аралдары',
    nameEN: 'Cocos Islands',
  },
  {
    phoneCode: '+57',
    code: 'CO',
    name: 'Колумбия',
    nameKK: 'Колумбия',
    nameEN: 'Colombia',
  },
  {
    phoneCode: '+269',
    code: 'KM',
    name: 'Коморские острова',
    nameKK: 'Комор аралдары',
    nameEN: 'Comoros',
  },
  {
    phoneCode: '+242',
    code: 'CG',
    name: 'Конго Республика',
    nameKK: 'Конго Республикасы',
    nameEN: 'Congo',
  },
  {
    phoneCode: '+242',
    code: 'CD',
    name: 'Конго, Демократическая Республика',
    nameKK: 'Конго, Демократиялық Республика',
    nameEN: 'Congo, Democratic Republic of the',
  },
  {
    phoneCode: '+850',
    code: 'KP',
    name: 'Корея (Северная), КНДР',
    nameKK: 'Корея (Солтүстік), КХДР',
    nameEN: 'Korea (North), DPRK',
  },
  {
    phoneCode: '+82',
    code: 'KR',
    name: 'Корея (Южная)',
    nameKK: 'Корея (Оңтүстік)',
    nameEN: 'Korea (South), ROK',
  },
  {
    phoneCode: '+506',
    code: 'CR',
    name: 'Коста-Рика',
    nameKK: 'Коста-Рика',
    nameEN: 'Costa Rica',
  },
  {
    phoneCode: '+225',
    code: 'CI',
    name: "Кот-д'Ивуар",
    nameKK: "Кот-д ' Ивуар",
    nameEN: "Côte d'Ivoire",
  },
  {
    phoneCode: '+53',
    code: 'CU',
    name: 'Куба',
    nameKK: 'Куба',
    nameEN: 'Cuba',
  },
  {
    phoneCode: '+965',
    code: 'KW',
    name: 'Кувейт',
    nameKK: 'Кувейт',
    nameEN: 'Kuwait',
  },
  {
    phoneCode: '+856',
    code: 'LA',
    name: 'Лаос',
    nameKK: 'Лаос',
    nameEN: 'Laos',
  },
  {
    phoneCode: '+371',
    code: 'LV',
    name: 'Латвия',
    nameKK: 'Латвия',
    nameEN: 'Latvia',
  },
  {
    phoneCode: '+266',
    code: 'LS',
    name: 'Лесото',
    nameKK: 'Лесото',
    nameEN: 'Lesotho',
  },
  {
    phoneCode: '+231',
    code: 'LR',
    name: 'Либерия',
    nameKK: 'Либерия',
    nameEN: 'Liberia',
  },
  {
    phoneCode: '+961',
    code: 'LB',
    name: 'Ливан',
    nameKK: 'Ливан',
    nameEN: 'Lebanon',
  },
  {
    phoneCode: '+218',
    code: 'LY',
    name: 'Ливия',
    nameKK: 'Ливия',
    nameEN: 'Libya',
  },
  {
    phoneCode: '+370',
    code: 'LT',
    name: 'Литва',
    nameKK: 'Литва',
    nameEN: 'Lithuania',
  },
  {
    phoneCode: '+423',
    code: 'LI',
    name: 'Лихтенштейн',
    nameKK: 'Лихтенштейн',
    nameEN: 'Liechtenstein',
  },
  {
    phoneCode: '+352',
    code: 'LU',
    name: 'Люксембург',
    nameKK: 'Люксембург',
    nameEN: 'Luxembourg',
  },
  {
    phoneCode: '+230',
    code: 'MU',
    name: 'Маврикий',
    nameKK: 'Маврикий',
    nameEN: 'Mauritius',
  },
  {
    phoneCode: '+222',
    code: 'MR',
    name: 'Мавритания',
    nameKK: 'Мавритания',
    nameEN: 'Mauritania',
  },
  {
    phoneCode: '+261',
    code: 'MG',
    name: 'Мадагаскар',
    nameKK: 'Мадагаскар',
    nameEN: 'Madagascar',
  },
  {
    phoneCode: '+269',
    code: 'YT',
    name: 'Майотт',
    nameKK: 'Майотт',
    nameEN: 'Mayotte',
  },
  {
    phoneCode: '+853',
    code: 'MO',
    name: 'Макао',
    nameKK: 'Макао',
    nameEN: 'Macau',
  },
  {
    phoneCode: '+389',
    code: 'MK',
    name: 'Македония',
    nameKK: 'Македония',
    nameEN: 'Macedonia',
  },
  {
    phoneCode: '+265',
    code: 'MW',
    name: 'Малави',
    nameKK: 'Малави',
    nameEN: 'Malawi',
  },
  {
    phoneCode: '+60',
    code: 'MY',
    name: 'Малайзия',
    nameKK: 'Малайзия',
    nameEN: 'Malaysia',
  },
  {
    phoneCode: '+223',
    code: 'ML',
    name: 'Мали',
    nameKK: 'Мали',
    nameEN: 'Mali',
  },
  {
    phoneCode: '+960',
    code: 'MV',
    name: 'Мальдивы',
    nameKK: 'Мальдив аралдары',
    nameEN: 'Maldives',
  },
  {
    phoneCode: '+356',
    code: 'MT',
    name: 'Мальта',
    nameKK: 'Мальта',
    nameEN: 'Malta',
  },
  {
    phoneCode: '+1670',
    code: 'MP',
    name: 'Марианские острова',
    nameKK: 'Мариана аралдары',
    nameEN: 'Northern Mariana Islands',
  },
  {
    phoneCode: '+212',
    code: 'MA',
    name: 'Марокко',
    nameKK: 'Марокко',
    nameEN: 'Morocco',
  },
  {
    phoneCode: '+692',
    code: 'MH',
    name: 'Маршалловы острова',
    nameKK: 'Маршалл аралдары',
    nameEN: 'Marshall Islands',
  },
  {
    phoneCode: '+52',
    code: 'MX',
    name: 'Мексика',
    nameKK: 'Мексика',
    nameEN: 'Mexico',
  },
  {
    phoneCode: '+691',
    code: 'FM',
    name: 'Микронезия',
    nameKK: 'Микронезия',
    nameEN: 'Micronesia',
  },
  {
    phoneCode: '+258',
    code: 'MZ',
    name: 'Мозамбик',
    nameKK: 'Мозамбик',
    nameEN: 'Mozambique',
  },
  {
    phoneCode: '+373',
    code: 'MD',
    name: 'Молдавия',
    nameKK: 'Молдова',
    nameEN: 'Moldova',
  },
  {
    phoneCode: '+377',
    code: 'MC',
    name: 'Монако',
    nameKK: 'Монако',
    nameEN: 'Monaco',
  },
  {
    phoneCode: '+976',
    code: 'MN',
    name: 'Монголия',
    nameKK: 'Моңғолия',
    nameEN: 'Mongolia',
  },
  {
    phoneCode: '+1664',
    code: 'MS',
    name: 'Монтсеррат',
    nameKK: 'Монсеррат',
    nameEN: 'Montserrat',
  },
  {
    phoneCode: '+95',
    code: 'MM',
    name: 'Мьянма',
    nameKK: 'Мьянма',
    nameEN: 'Myanmar',
  },
  {
    phoneCode: '+264',
    code: 'NA',
    name: 'Намибия',
    nameKK: 'Намибия',
    nameEN: 'Namibia',
  },
  {
    phoneCode: '+674',
    code: 'NR',
    name: 'Науру',
    nameKK: 'Науру',
    nameEN: 'Nauru',
  },
  {
    phoneCode: '+977',
    code: 'NP',
    name: 'Непал',
    nameKK: 'Непал',
    nameEN: 'Nepal',
  },
  {
    phoneCode: '+227',
    code: 'NE',
    name: 'Нигер',
    nameKK: 'Нигер',
    nameEN: 'Niger',
  },
  {
    phoneCode: '+234',
    code: 'NG',
    name: 'Нигерия',
    nameKK: 'Нигерия',
    nameEN: 'Nigeria',
  },
  {
    phoneCode: '+31',
    code: 'NL',
    name: 'Нидерланды',
    nameKK: 'Нидерланды',
    nameEN: 'Netherlands',
  },
  {
    phoneCode: '+505',
    code: 'NI',
    name: 'Никарагуа',
    nameKK: 'Никарагуа',
    nameEN: 'Nicaragua',
  },
  {
    phoneCode: '+683',
    code: 'NU',
    name: 'Ниуэ',
    nameKK: 'Ниуэ',
    nameEN: 'Niue',
  },
  {
    phoneCode: '+64',
    code: 'NZ',
    name: 'Новая Зеландия',
    nameKK: 'Жаңа Зеландия',
    nameEN: 'New Zealand',
  },
  {
    phoneCode: '+687',
    code: 'NC',
    name: 'Новая Каледония',
    nameKK: 'Жаңа Каледония',
    nameEN: 'New Caledonia',
  },
  {
    phoneCode: '+47',
    code: 'NO',
    name: 'Норвегия',
    nameKK: 'Норвегия',
    nameEN: 'Norway',
  },
  {
    phoneCode: '+971',
    code: 'AE',
    name: 'Объединенные Арабские Эмираты',
    nameKK: 'Біріккен Араб Әмірліктері',
    nameEN: 'United Arab Emirates',
  },
  {
    phoneCode: '+968',
    code: 'OM',
    name: 'Оман',
    nameKK: 'Оман',
    nameEN: 'Oman',
  },
  {
    phoneCode: '+44',
    code: 'IM',
    name: 'Остров Мэн',
    nameKK: 'Мэн Аралы',
    nameEN: 'Isle of Man',
  },
  {
    phoneCode: '+6724',
    code: 'CX',
    name: 'Остров Рождества',
    nameKK: 'Рождество Аралы',
    nameEN: 'Christmas Island',
  },
  {
    phoneCode: '+290',
    code: 'SH',
    name: 'Остров Святой Елены',
    nameKK: 'Әулие Елена Аралы',
    nameEN: 'Saint Helena',
  },
  {
    phoneCode: '+44153',
    code: 'JE',
    name: 'Острова Джерси',
    nameKK: 'Джерси Аралдары',
    nameEN: 'Jersey',
  },
  {
    phoneCode: '+682',
    code: 'CK',
    name: 'Острова Кука',
    nameKK: 'Кук Аралдары',
    nameEN: 'Cook Islands',
  },
  {
    phoneCode: '+1649',
    code: 'TC',
    name: 'Острова Теркс и Кайкос',
    nameKK: 'Түріктер мен Кайкос аралдары',
    nameEN: 'Turks and Caicos Islands',
  },
  {
    phoneCode: '+681',
    code: 'WF',
    name: 'Острова Уоллис и Футуна',
    nameKK: 'Уоллис және Футуна аралдары',
    nameEN: 'Wallis and Futuna',
  },
  {
    phoneCode: '+47',
    code: 'SJ',
    name: 'Острова Шпицберген и Ян-Майен',
    nameKK: 'Шпицберген және Ян-Майен аралдары',
    nameEN: 'Svalbard and Jan Mayen',
  },
  {
    phoneCode: '+92',
    code: 'PK',
    name: 'Пакистан',
    nameKK: 'Пәкістан',
    nameEN: 'Pakistan',
  },
  {
    phoneCode: '+680',
    code: 'PW',
    name: 'Палау',
    nameKK: 'Палау',
    nameEN: 'Palau',
  },
  {
    phoneCode: '+972',
    code: 'PS',
    name: 'Палестина',
    nameKK: 'Палестина',
    nameEN: 'Palestine',
  },
  {
    phoneCode: '+507',
    code: 'PA',
    name: 'Панама',
    nameKK: 'Панама',
    nameEN: 'Panama',
  },
  {
    phoneCode: '+675',
    code: 'PG',
    name: 'Папуа-Новая Гвинея',
    nameKK: 'Папуа-Жаңа Гвинея',
    nameEN: 'Papua New Guinea',
  },
  {
    phoneCode: '+595',
    code: 'PY',
    name: 'Парагвай',
    nameKK: 'Парагвай',
    nameEN: 'Paraguay',
  },
  {
    phoneCode: '+51',
    code: 'PE',
    name: 'Перу',
    nameKK: 'Перу',
    nameEN: 'Peru',
  },
  {
    phoneCode: '+64',
    code: 'PN',
    name: 'Питкерн',
    nameKK: 'Питкерн',
    nameEN: 'Pitcairn',
  },
  {
    phoneCode: '+689',
    code: 'PF',
    name: 'Полинезия',
    nameKK: 'Полинезия',
    nameEN: 'Polynesia',
  },
  {
    phoneCode: '+48',
    code: 'PL',
    name: 'Польша',
    nameKK: 'Польша',
    nameEN: 'Poland',
  },
  {
    phoneCode: '+351',
    code: 'PT',
    name: 'Португалия',
    nameKK: 'Португалия',
    nameEN: 'Portugal',
  },
  {
    phoneCode: '+262',
    code: 'RE',
    name: 'Реюньон',
    nameKK: 'Реюньон',
    nameEN: 'Reunion',
  },
  {
    phoneCode: '+250',
    code: 'RW',
    name: 'Руанда',
    nameKK: 'Руанда',
    nameEN: 'Rwanda',
  },
  {
    phoneCode: '+40',
    code: 'RO',
    name: 'Румыния',
    nameKK: 'Румыния',
    nameEN: 'Romania',
  },
  {
    phoneCode: '+685',
    code: 'WS',
    name: 'Самоа',
    nameKK: 'Самоа',
    nameEN: 'Samoa',
  },
  {
    phoneCode: '+378',
    code: 'SM',
    name: 'Сан-Марино',
    nameKK: 'Сан-Марино',
    nameEN: 'San Marino',
  },
  {
    phoneCode: '+239',
    code: 'ST',
    name: 'Сан-Томе и Принсипи',
    nameKK: 'Сан-Томе және Принсипи',
    nameEN: 'Sao Tome and Principe',
  },
  {
    phoneCode: '+966',
    code: 'SA',
    name: 'Саудовская Аравия',
    nameKK: 'Сауд Арабиясы',
    nameEN: 'Saudi Arabia',
  },
  {
    phoneCode: '+268',
    code: 'SZ',
    name: 'Свазиленд',
    nameKK: 'Свазиленд',
    nameEN: 'Swaziland',
  },
  {
    phoneCode: '+248',
    code: 'SC',
    name: 'Сейшельские острова',
    nameKK: 'Сейшел аралдары',
    nameEN: 'Seychelles',
  },
  {
    phoneCode: '+221',
    code: 'SN',
    name: 'Сенегал',
    nameKK: 'Сенегал',
    nameEN: 'Senegal',
  },
  {
    phoneCode: '+1784',
    code: 'VC',
    name: 'Сент-Винсент и Гренадины',
    nameKK: 'Сент-Винсент және Гренадиндер',
    nameEN: 'Saint Vincent and the Grenadines',
  },
  {
    phoneCode: '+1869',
    code: 'KN',
    name: 'Сент-Китс и Невис',
    nameKK: 'Сент-Китс және Невис',
    nameEN: 'Saint Kitts and Nevis',
  },
  {
    phoneCode: '+1758',
    code: 'LC',
    name: 'Сент-Люсия',
    nameKK: 'Сент-Люсия',
    nameEN: 'Saint Lucia',
  },
  {
    phoneCode: '+508',
    code: 'PM',
    name: 'Сент-Пьер и Микелон',
    nameKK: 'Сент-Пьер және Микелон',
    nameEN: 'Saint Pierre and Miquelon',
  },
  {
    phoneCode: '+381',
    code: 'RS',
    name: 'Сербия',
    nameKK: 'Сербия',
    nameEN: 'Serbia',
  },
  {
    phoneCode: '+65',
    code: 'SG',
    name: 'Сингапур',
    nameKK: 'Сингапур',
    nameEN: 'Singapore',
  },
  {
    phoneCode: '+963',
    code: 'SY',
    name: 'Сирия',
    nameKK: 'Сирия',
    nameEN: 'Syria',
  },
  {
    phoneCode: '+421',
    code: 'SK',
    name: 'Словакия',
    nameKK: 'Словакия',
    nameEN: 'Slovakia',
  },
  {
    phoneCode: '+386',
    code: 'SI',
    name: 'Словения',
    nameKK: 'Словения',
    nameEN: 'Slovenia',
  },
  {
    phoneCode: '+677',
    code: 'SB',
    name: 'Соломоновы острова',
    nameKK: 'Соломон аралдары',
    nameEN: 'Solomon Islands',
  },
  {
    phoneCode: '+252',
    code: 'SO',
    name: 'Сомали',
    nameKK: 'Сомали',
    nameEN: 'Somalia',
  },
  {
    phoneCode: '+249',
    code: 'SD',
    name: 'Судан',
    nameKK: 'Судан',
    nameEN: 'Sudan',
  },
  {
    phoneCode: '+597',
    code: 'SR',
    name: 'Суринам',
    nameKK: 'Суринам',
    nameEN: 'Suriname',
  },
  {
    phoneCode: '+1',
    code: 'US',
    name: 'США',
    nameKK: 'АҚШ',
    nameEN: 'United States',
  },
  {
    phoneCode: '+232',
    code: 'SL',
    name: 'Сьерра-Леоне',
    nameKK: 'Сьерра-Леоне',
    nameEN: 'Sierra Leone',
  },
  {
    phoneCode: '+992',
    code: 'TJ',
    name: 'Таджикистан',
    nameKK: 'Тәжікстан',
    nameEN: 'Tajikistan',
  },
  {
    phoneCode: '+66',
    code: 'TH',
    name: 'Таиланд',
    nameKK: 'Тайланд',
    nameEN: 'Thailand',
  },
  {
    phoneCode: '+886',
    code: 'TW',
    name: 'Тайвань',
    nameKK: 'Тайвань',
    nameEN: 'Taiwan',
  },
  {
    phoneCode: '+255',
    code: 'TZ',
    name: 'Танзания',
    nameKK: 'Танзания',
    nameEN: 'Tanzania',
  },
  {
    phoneCode: '+228',
    code: 'TG',
    name: 'Того',
    nameKK: 'Того',
    nameEN: 'Togo',
  },
  {
    phoneCode: '+690',
    code: 'TK',
    name: 'Токелау',
    nameKK: 'Токелау',
    nameEN: 'Tokelau',
  },
  {
    phoneCode: '+676',
    code: 'TO',
    name: 'Тонга',
    nameKK: 'Тонга',
    nameEN: 'Tonga',
  },
  {
    phoneCode: '+1868',
    code: 'TT',
    name: 'Тринидад и Тобаго',
    nameKK: 'Тринидад және Тобаго',
    nameEN: 'Trinidad and Tobago',
  },
  {
    phoneCode: '+688',
    code: 'TV',
    name: 'Тувалу',
    nameKK: 'Тувалу',
    nameEN: 'Tuvalu',
  },
  {
    phoneCode: '+216',
    code: 'TN',
    name: 'Тунис',
    nameKK: 'Тунис',
    nameEN: 'Tunisia',
  },
  {
    phoneCode: '+993',
    code: 'TM',
    name: 'Туркменистан',
    nameKK: 'Түрікменстан',
    nameEN: 'Turkmenistan',
  },
  {
    phoneCode: '+90',
    code: 'TR',
    name: 'Турция',
    nameKK: 'Түркия',
    nameEN: 'Turkey',
  },
  {
    phoneCode: '+256',
    code: 'UG',
    name: 'Уганда',
    nameKK: 'Уганда',
    nameEN: 'Uganda',
  },
  {
    phoneCode: '+380',
    code: 'UA',
    name: 'Украина',
    nameKK: 'Украина',
    nameEN: 'Ukraine',
  },
  {
    phoneCode: '+598',
    code: 'UY',
    name: 'Уругвай',
    nameKK: 'Уругвай',
    nameEN: 'Uruguay',
  },
  {
    phoneCode: '+298',
    code: 'FO',
    name: 'Фарерские острова',
    nameKK: 'Фарер аралдары',
    nameEN: 'Faroe Islands',
  },
  {
    phoneCode: '+679',
    code: 'FJ',
    name: 'Фиджи',
    nameKK: 'Фиджи',
    nameEN: 'Fiji',
  },
  {
    phoneCode: '+63',
    code: 'PH',
    name: 'Филиппины',
    nameKK: 'Филиппин',
    nameEN: 'Philippines',
  },
  {
    phoneCode: '+358',
    code: 'FI',
    name: 'Финляндия',
    nameKK: 'Финляндия',
    nameEN: 'Finland',
  },
  {
    phoneCode: '+500',
    code: 'FK',
    name: 'Фолклендские острова',
    nameKK: 'Фолкленд аралдары',
    nameEN: 'Falkland Islands',
  },
  {
    phoneCode: '+33',
    code: 'FR',
    name: 'Франция',
    nameKK: 'Франция',
    nameEN: 'France',
  },
  {
    phoneCode: '+385',
    code: 'HR',
    name: 'Хорватия',
    nameKK: 'Хорватия',
    nameEN: 'Croatia',
  },
  {
    phoneCode: '+236',
    code: 'CF',
    name: 'Центральноафриканская Республика',
    nameKK: 'Орталық Африка Республикасы',
    nameEN: 'Central African Republic',
  },
  {
    phoneCode: '+235',
    code: 'TD',
    name: 'Чад',
    nameKK: 'Чад',
    nameEN: 'Chad',
  },
  {
    phoneCode: '+382',
    code: 'ME',
    name: 'Черногория',
    nameKK: 'Черногория',
    nameEN: 'Montenegro',
  },
  {
    phoneCode: '+420',
    code: 'CZ',
    name: 'Чешская Республика',
    nameKK: 'Чех Республикасы',
    nameEN: 'Czech Republic',
  },
  {
    phoneCode: '+56',
    code: 'CL',
    name: 'Чили',
    nameKK: 'Чили',
    nameEN: 'Chile',
  },
  {
    phoneCode: '+41',
    code: 'CH',
    name: 'Швейцария',
    nameKK: 'Швейцария',
    nameEN: 'Switzerland',
  },
  {
    phoneCode: '+46',
    code: 'SE',
    name: 'Швеция',
    nameKK: 'Швеция',
    nameEN: 'Sweden',
  },
  {
    phoneCode: '+94',
    code: 'LK',
    name: 'Шри-Ланка',
    nameKK: 'Шри-Ланка',
    nameEN: 'Sri Lanka',
  },
  {
    phoneCode: '+593',
    code: 'EC',
    name: 'Эквадор',
    nameKK: 'Эквадор',
    nameEN: 'Ecuador',
  },
  {
    phoneCode: '+240',
    code: 'GQ',
    name: 'Экваториальная Гвинея',
    nameKK: 'Экваторлық Гвинея',
    nameEN: 'Equatorial Guinea',
  },
  {
    phoneCode: '+503',
    code: 'SV',
    name: 'Эль-Сальвадор',
    nameKK: 'Эль-Сальвадор',
    nameEN: 'El Salvador',
  },
  {
    phoneCode: '+291',
    code: 'ER',
    name: 'Эритрея',
    nameKK: 'Эритрея',
    nameEN: 'Eritrea',
  },
  {
    phoneCode: '+372',
    code: 'EE',
    name: 'Эстония',
    nameKK: 'Эстония',
    nameEN: 'Estonia',
  },
  {
    phoneCode: '+251',
    code: 'ET',
    name: 'Эфиопия',
    nameKK: 'Эфиопия',
    nameEN: 'Ethiopia',
  },
  {
    phoneCode: '+27',
    code: 'ZA',
    name: 'Южно-Африканская Республика',
    nameKK: 'Оңтүстік Африка Республикасы',
    nameEN: 'South Africa',
  },
  {
    phoneCode: '+1876',
    code: 'JM',
    name: 'Ямайка',
    nameKK: 'Ямайка',
    nameEN: 'Jamaica',
  },
  {
    phoneCode: '+81',
    code: 'JP',
    name: 'Япония',
    nameKK: 'Жапония',
    nameEN: 'Japan',
  },
];

export const KAZAKHSTAN_CODE = 'KZ';
export const AZERBAIJAN_CODE = 'AZ';
export const TURKEY_CODE = 'TR';
export const TAJIKISTAN_CODE = 'TJ';
export const countriesWithoutSeries = [
  KAZAKHSTAN_CODE,
  TURKEY_CODE,
  TAJIKISTAN_CODE,
];
